// frontend/src/components/purchase-orders/poReceiptColumns.js
//
// Whether a purchase order's lines show their receipt columns (received,
// remaining, last received) — the one home for that rule, read by the PO
// details grid and the PO list's expanded row. A draft owes nothing yet, and a
// cancelled PO never received anything (`cancel` refuses a PO with receipts),
// so neither has receipts to show.

const SHOWS_RECEIPTS = Object.freeze({
  draft: false,
  open: true,
  partially_received: true,
  received: true,
  closed: true,
  cancelled: false,
});

export function poShowsReceipts(status) {
  if (!(status in SHOWS_RECEIPTS)) {
    // An unknown status must not quietly hide or show what was received.
    throw new Error(`poShowsReceipts: unknown status "${status}"`);
  }
  return SHOWS_RECEIPTS[status];
}
